module.exports = __webpack_public_path__ + "static/media/navodaya_banner.6a8db92b.jpg";